import React, { useState } from "react";
import SecondaryHeading from "../Typography/SecondaryHeading";
import Paragraph from "../Typography/Paragraph";
import SpecialText from "../Typography/SpecialText";
import { Link } from "react-router-dom";
import {
  PUBLIC_BLOG_LIST_DIVIDER_CLASS,
  PUBLIC_IMAGE_TO_HEADING_CLASS,
  PUBLIC_HEADING_TO_BODY_CLASS,
  PUBLIC_HEADING_ROW_GAP_CLASS,
} from "../../../sections/Public/shared/publicLayoutSpec";

const BlogDesign = ({ heading, para, timing }) => {
  const [isHovered, setIsHovered] = useState(false);
  return (
    <>
      <div className={PUBLIC_BLOG_LIST_DIVIDER_CLASS}>
        <div className={`flex ${PUBLIC_HEADING_ROW_GAP_CLASS} h-[150px] sm:h-[225px]`}>
          <div className="w-[140px] h-[150px] sm:w-[200px] sm:h-[225px] flex-shrink-0">
            <Link
              to={"/blogs/article-id-will-be-here"}
              onMouseEnter={() => setIsHovered(true)}
              onMouseLeave={() => setIsHovered(false)}
            >
              <img
                src={require("../../../assets/img/default-image.jpg")}
                alt="blog title"
                className="w-full h-full rounded-xl shrink-0 object-cover"
              />
            </Link>
          </div>
          <div>
            <Link
              to={"/blogs/article-id-will-be-here"}
              onMouseEnter={() => setIsHovered(true)}
              onMouseLeave={() => setIsHovered(false)}
            >
              <SecondaryHeading
                variant={"MainParagraphHeading"}
                className={`${isHovered ? "text-primaryblue" : ""} transition-colors duration-200`}
              >
                {heading}
              </SecondaryHeading>
            </Link>
            <Paragraph
              variant={"MainParagraph"}
              className={`${PUBLIC_IMAGE_TO_HEADING_CLASS} overflow-hidden text-ellipsis h-[58px] sm:h-[77px] lg:h-auto`}
            >
              {para}
            </Paragraph>
            <SpecialText
              variant={"DateStamp"}
              className={`${PUBLIC_HEADING_TO_BODY_CLASS} text-offblack`}
            >
              {timing}
            </SpecialText>
          </div>
        </div>
      </div>
    </>
  );
};

export default BlogDesign;
